import React from "react";
import getConfig from 'next/config';
import { useNavbarContext } from '../Navbar';
import './NavBrand.scss';

export const NavBrand = ({
  isOffcanvas
}) => {
  const { logoPath } = useNavbarContext();
  const { BASE_URL } = getConfig().publicRuntimeConfig;

  return (
    <div className={`navbar-brand  ${isOffcanvas ? 'offcanvas' : ''}`}>
      <a
        href={`/`}
        className='link'
      >
        <img
          src={logoPath}
          alt="lifepal-user-logo"
          className='logo'
          width="93"
          height="32"
          fetchPriority="low"
        />
      </a>
    </div>
  );
}